import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'mono-common-header-logo',
  templateUrl: './header-logo.component.html'
})
export class HeaderLogoComponent implements OnInit {

  @Input() logoSrc: string;
  @Input() homePageAltText: string;
  @Input() nonHomePageAltText: string;

  public currentRoute: string;

  constructor(private location: Location, private router: Router) { }

  ngOnInit(): void {
    this.currentRoute = this.location.path();
    this.router.events.subscribe(() => {
      this.currentRoute = this.location.path();
    });
  }

}